export default __webpack_public_path__ + "static/media/Download.6b97cae9.svg";